import React from "react";
import { RecoilRoot } from "recoil";

type RecoilProviderProps = { readonly children: JSX.Element };

const RecoilProvider = ({ children }: RecoilProviderProps): JSX.Element => <RecoilRoot>{children}</RecoilRoot>;

export default RecoilProvider;
